import React, { useEffect, useRef, useState } from 'react';
import './Philosophy.css';
import { useLanguage } from '../context/LanguageContext';

const phaseImages = ["/PHASE 1.png", "/PHASE 2.png", "/PHASE 3.png", "/PHASE 4.png"];

const Philosophy = () => {
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="philosophy" id="philosophy" ref={sectionRef}>
      <div className="philosophy-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
      </div>

      <div className={`philosophy-content ${isInView ? 'visible' : ''}`}>
        <div className="philosophy-header">
          <span className="section-label">{t.philosophy.sectionLabel}</span>
          <h2 className="section-title">
            <span>{t.philosophy.sectionTitle1}</span>
            <span className="accent">{t.philosophy.sectionTitle2}</span>
          </h2>
          <p className="section-subtitle">{t.philosophy.sectionSubtitle}</p>
        </div>

        <div className="phases-grid">
          {t.philosophy.phases.map((phase, index) => (
            <div 
              key={index} 
              className="phase-card"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="phase-image">
                <img src={phaseImages[index]} alt={phase.title} />
                <div className="phase-number">{phase.number}</div>
              </div>
              <h3 className="phase-title">{phase.title}</h3>
              <p className="phase-description">{phase.description}</p>
            </div>
          ))}
        </div>

        <div className="philosophy-code">
          <h3 className="code-title">{t.philosophy.manifestoTitle}</h3>
          <div className="code-lines">
            {t.philosophy.manifesto.map((line, index) => (
              <div 
                key={index} 
                className="code-line"
                style={{ animationDelay: `${0.6 + index * 0.15}s` }}
              >
                <span className="code-number">{String(index + 1).padStart(2, '0')}</span>
                <span className="code-text">{line}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="philosophy-quote">
          <blockquote>
            {t.philosophy.quote}
          </blockquote>
          <cite>{t.philosophy.quoteAuthor}</cite>
        </div>

        <div className="philosophy-stats">
          <div className="stat-item">
            <span className="stat-number">{t.philosophy.stats.origin.value}</span>
            <span className="stat-label">{t.philosophy.stats.origin.label}</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">{t.philosophy.stats.abv.value}</span>
            <span className="stat-label">{t.philosophy.stats.abv.label}</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">{t.philosophy.stats.filtered.value}</span>
            <span className="stat-label">{t.philosophy.stats.filtered.label}</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">{t.philosophy.stats.grapes.value}</span>
            <span className="stat-label">{t.philosophy.stats.grapes.label}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
